<div class="header_desarrollo text-center py-3 mb-5">
  <img class="header-logo img-fluid shadow rounded" src="assets/img/headers/header-oficina-virtual.png"
    alt="Encabezado"/>
</div>
